import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  inject
} from '@angular/core';
import { FormArray } from '@angular/forms';
import { createMask } from '@ngneat/input-mask';
import { ProposalRequestVendorForm } from 'src/app/classes/form-groups/proposal-request-vendor-form';
import { SubNationalDivision } from 'src/app/classes/models';
import { LocalizationInfo } from 'src/app/interfaces/localization-info';
import { SubNationalDivisionService } from 'src/app/services/sub-national-division.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-add-edit-proposal-request-vendor',
  templateUrl: './add-edit-proposal-request-vendor.component.html',
  styleUrl: './add-edit-proposal-request-vendor.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddEditProposalRequestVendorComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private ToastService: ToastService,
    private SubNationalDivisionService: SubNationalDivisionService
  ) {}

  @ViewChild('emailTagfield') emailTagfield!: ElementRef<HTMLElement>;

  @Input()
  ProposalRequestVendorFormArray!: FormArray<ProposalRequestVendorForm>;
  @Input() LocalizationInfo!: LocalizationInfo;
  @Input() country!: 'US' | 'CA';

  ProposalRequestVendorEmailMap = new Map<
    ProposalRequestVendorForm,
    string[]
  >();

  SubNationalDivisions: SubNationalDivision[] = [];

  usZipMask = createMask('99999');
  canadianZipMask = createMask('A9A 9A9');
  phoneMask = createMask('(999) 999-9999');
  phoneExtensionMask = createMask({ regex: '\\d{1,6}', placeholder: '' });

  updateEmail(
    ProposalRequestVendorFormGroup: ProposalRequestVendorForm,
    emails: string
  ) {
    ProposalRequestVendorFormGroup.patchValue({
      email: emails
    });
    this._cdr.markForCheck();
  }

  ngOnInit(): void {
    if (!this.ProposalRequestVendorFormArray) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing bid request vendor forms.',
        { returnError: true }
      );
    }

    if (!this.LocalizationInfo) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing localization information.',
        { returnError: true }
      );
    }

    if (!this.country) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing country information.',
        { returnError: true }
      );
    }

    this.ProposalRequestVendorFormArray.controls.forEach(
      (ProposalRequestVendorFormGroup) => {
        const {
          value: { email }
        } = ProposalRequestVendorFormGroup;

        const emailsForTagfield =
          email
            ?.split(/[,;]/)
            .map((e) => e.trim())
            .filter((e) => e) || [];

        this.ProposalRequestVendorEmailMap.set(
          ProposalRequestVendorFormGroup,
          emailsForTagfield
        );
      }
    );

    this.SubNationalDivisionService.getSubNationalDivisions({
      country: this.country
    }).subscribe({
      next: (SubNationalDivisions) => {
        this.SubNationalDivisions.push(...SubNationalDivisions);
        this._cdr.markForCheck();
      }
    });
  }
}
